if (!customElements.get('variant-msrp')) {
  customElements.define('variant-msrp', class VariantMSRP extends HTMLElement {
    constructor() {
      super();
      if (this.querySelector('#msrp-display')) {
        this.msrpDisplay = this.querySelector('#msrp-display');
        this.init();
      }
    }
    init() {
      this.setupEventListeners();
      this.updateMSRPForCurrentVariant();
    }
    setupEventListeners() {
      // GLO swatch clicks and changes
      document.body.addEventListener('click', (e) => {
        const label = e.target.closest('.swatch-anchor');
        if (label) {
          setTimeout(() => this.updateMSRPForCurrentVariant(), 100);
        }
      }, true);
      // Radio button changes
      document.body.addEventListener('change', (e) => {
        if (e.target.matches('input[name^="option-globo"]')) {
          setTimeout(() => this.updateMSRPForCurrentVariant(), 100);
        }
      }, true);
      // Monitor for any changes to the .select-option elements
      const observer = new MutationObserver(() => {
        this.updateMSRPForCurrentVariant();
      });
      document.querySelectorAll('.globo-swatch-list').forEach(el => {
        observer.observe(el, {
          subtree: true,
          attributes: true,
          attributeFilter: ['checked', 'class']
        });
      });
    }
    updateMSRPForCurrentVariant() {
      setTimeout(() => {
        let variantId;
        // Try to get variantId from checked radio
        const checkedInput = document.querySelector('input[name^="option-globo"]:checked');
        if (checkedInput) {
          const container = checkedInput.closest('.select-option');
          if (container) {
            variantId = container.dataset.variantid;
          }
        }
        // Backup: try to find from hidden input
        if (!variantId) {
          const hiddenInput = document.querySelector('input[name="id"][type="hidden"]');
          variantId = hiddenInput?.value;
        }
        if (!variantId || !this.msrpDisplay) return;
        const msrpElement = this.querySelector(`[data-variant-id="${variantId}"]`);
        if (!msrpElement) return;
        const msrpValue = msrpElement.dataset.msrp;
        if (!msrpValue) return;
        // Force update
        this.msrpDisplay.style.opacity = '.5';
        requestAnimationFrame(() => {
          this.msrpDisplay.innerHTML = `MSRP: ${new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
          }).format(msrpValue)}`;
          this.msrpDisplay.style.opacity = '1';
        });
      }, 1000);
    }
  });
}